<template>
  <div>
    <h1 class="page-header">
      {{ $t('administration.employee.employeeCardActivator.cardActivator') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end ts-space-x-2"
              >
                <select
                  class="form-control"
                  v-model.number="status_id"
                  style="width: 120px"
                  @change="fetchData()"
                >
                  <option :value="1">Active</option>
                  <option :value="2">In Active</option>
                </select>
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">
                {{ record.branch ? record.branch.branch_name_en : '' }}
              </td>
            
              <td class="ts-whitespace-no-wrap">
                {{
                  record.employee
                    ? record.employee.name_en + '|' + record.employee.name_kh
                    : ''
                }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.serial_card }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.registered_date }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                <span class="label label-success" v-if="record.status_id == 1"
                  >Active</span
                >
                <span class="label label-default" v-if="record.status_id == 2"
                  >Inactive</span
                >
              </td>
              <td class="ts-whitespace-no-wrap">{{ record.reason }}</td>
              <td class="ts-whitespace-no-wrap text-center">
                <a
                  href="#"
                  v-tooltip="$t('studentCardActivator.changeStatus')"
                  class="text-primary"
                  @click.prevent="change(record)"
                >
                  <i class="fas fa-random"></i>
                </a>
              </td>
            </template>
          </ts-table>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import FormComponent from './confirm-deactivate-old-card.vue'
export default {
  components: {
    FormCreate,
    FormComponent
  },
  name: 'employee-card-activator',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false,
      columns: [
        {
          name: this.$t('administration.employee.employeeCardActivator.branch')
        },
       
        {
          name: this.$t(
            'administration.employee.employeeCardActivator.employeeName'
          )
        },

        {
          name: this.$t(
            'administration.employee.employeeCardActivator.serialCard'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t(
            'administration.employee.employeeCardActivator.registerDate'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t('administration.employee.employeeCardActivator.status'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('administration.employee.employeeCardActivator.reason')
        },
        {
          name: 'Action',
          style: 'text-align:center'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('employeeCardActivator', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.employeeCardActivator.search
      },
      set (newVal) {
        this.$store.commit('employeeCardActivator/SET_SEARCH', newVal)
        this.$store.commit('employeeCardActivator/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get () {
        return this.$store.state.employeeCardActivator.status_id
      },
      set (newVal) {
        this.$store.commit('employeeCardActivator/SET_STATUS_ID', newVal)
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch('employeeCardActivator/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    change (record) {
      this.$modal.show(
        FormComponent,
        {
          data: {
            staff_id: parseInt(record.staff_id),
            serial_card: ''
          }
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'employee-card-activator-create') {
      this.$store.commit('employeeCardActivator/RESET_STATE')
      this.$store.commit('employeeCardActivator/SET_EMPLOYEES', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
